import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const ServiceCatalogPageContent = lazy(() => import("./ServiceCatalogPageContent"));

function ServiceCatalogPageInternal() {
    return (
        <DefaultPage>
            <ServiceCatalogPageContent />
        </DefaultPage>
    );
}

export const ServiceCatalogPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    ServiceCatalogPageInternal
);
